.modalHeader {
  /* Unexpected browser feature "css-sticky" is only partially supported by Edge 87,88, Chrome 87,88, Opera 71,72 */
  /* stylelint-disable-next-line plugin/no-unsupported-browser-features */
  cursor: default;
  background: transparent;
  padding: 0px 15px 24px;
  color: var(--primary-100);
  display: flex;
  width: 100%;
  text-align: left;
  font:
    normal normal bold 2rem Rubik,
    sans-serif;
  box-sizing: border-box;
}

.modalClose {
  border: none;
  outline: none;
  display: inline-block;
  margin-left: auto;
  cursor: pointer;
  text-decoration: none;
}

.modalContent {
  padding: 0px 15px;
  box-sizing: border-box;
}

.actionBar {
  cursor: default;
  background: transparent;
  color: var(--text);
  font-weight: 600;
  font-size: 1.2rem;
  display: flex;
  width: 100%;
  justify-content: space-between;
  box-sizing: border-box;
}

.actionBar button,
.actionBar a {
  outline: none;
  cursor: pointer;
  color: var(--warning-60);
  font:
    normal normal bold 16px/21px Roboto,
    sans-serif;
  background: transparent;
  padding: 8px 16px;
  border: 2px solid transparent;
  margin-left: 15px;
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: 1.12px;
}

.actionBar button.active,
.actionBar a.active {
  background: var(--primary-60) 0% 0% no-repeat padding-box;
  color: #ffffff;
  border-radius: 20px;
  border: transparent;
  font:
    normal normal medium 18px/24px Roboto,
    sans-serif;
  padding: 13px;
}

.active i {
  display: block;
  font-size: 1.5rem;
  height: 1.5rem !important;
}

.closeButton {
  color: var(--warning-60);
  font:
    normal normal bold 16px/21px Roboto,
    sans-serif;
}
